module.exports = __webpack_public_path__ + "static/media/veradigm-background.052a5347.png";